import actionCreators from 'actionCreators';
import { useActions } from 'components/shared/hooks/useActions';
import { useSelector } from 'react-redux';
import { EstheticianMessagingDialog } from 'components/shared/Dialogs/esthetician-messaging';
import { sharedMessagingSidecarStyles } from 'components/Layout/MessageEstheticianChatButton/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { useSidecar } from 'providers';
import { useEffect } from 'react';
import { useAuth } from 'features/auth';

export const useMessages = (reLoadConversations = false) => {
  const actions = useActions(actionCreators.messageActions);
  const messaging = useSelector(state => state.toJS().messaging);
  const { open: openSidecar } = useSidecar();
  const { pathname, search, state } = useLocation();
  const { replace } = useHistory();
  const { isCustomer, user } = useAuth();

  useEffect(() => {
    if (!user?.get('id')) return;
    const alreadyLoaded =
      JSON.stringify(messaging.conversationsByConversationSid) !== '{}';
    if (!reLoadConversations || alreadyLoaded) return;
    actions.loadConversations();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(search);
    if (!params.size) return;

    const shouldOpenMessaging = JSON.parse(params.get('messaging')) === true;
    if (!shouldOpenMessaging) return;

    if (isCustomer) handleOpenMessaging();

    // Remove the query param from the url, so that messaging only appears on first load
    params.delete('messaging');
    replace({ pathname, search: params.toString(), state });
  }, [search]);

  const handleOpenMessaging = () => {
    // Clear any default messages set in the state.
    if (messaging.message) actions.removeMessage();

    openSidecar({
      component: EstheticianMessagingDialog,
      props: {
        sx: { margin: '0 !important' },
      },
      containerProps: {
        hideCloseButton: true,
        paperStyles: sharedMessagingSidecarStyles,
      },
    });
  };

  return {
    actions,
    messaging,
    handleOpenMessaging,
    conversationsByConversationSid: messaging.conversationsByConversationSid,
  };
};
